import { render, staticRenderFns } from "./MateriaisList.vue?vue&type=template&id=6f07e49d&scoped=true"
import script from "./MateriaisList.vue?vue&type=script&lang=js"
export * from "./MateriaisList.vue?vue&type=script&lang=js"
import style0 from "./MateriaisList.vue?vue&type=style&index=0&id=6f07e49d&prod&scoped=true&lang=css"
import style1 from "./MateriaisList.vue?vue&type=style&index=1&id=6f07e49d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07e49d",
  null
  
)

export default component.exports